import { AudioDownloadRenderingStatus } from 'services/api/entities/audioDownloadRendering';

export enum DownloadOption {
  Mp3 = 'mp3',
  Wav = 'wav',
  PdfLicense = 'pdf_license',
  Stems = 'stems',
  SamplePack = 'sample_pack',
}

interface SongDownloadInfo {
  type: DownloadOption;
}

interface StemsDownloadInfo {
  type: DownloadOption.Stems;
  status: AudioDownloadRenderingStatus;
}

interface SamplePackDownloadInfo {
  type: DownloadOption.SamplePack;
  status: AudioDownloadRenderingStatus;
}

export type DownloadInfo =
  | SongDownloadInfo
  | StemsDownloadInfo
  | SamplePackDownloadInfo;
